import { PageTypeHandle } from '~~/src/@types/type-handle';

export const printFooterImports: Partial<
  Record<PageTypeHandle, ReturnType<typeof defineAsyncComponent>>
> = {
  [PageTypeHandle.OFFER]: defineAsyncComponent(
    () => import('./offer/footer.vue'),
  ),
};

export default printFooterImports;
